 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"360da5eca0b125ca379890c902ea6c3521fb822f","2":"b51fa1b0004917ec479d531c8197e862e26a29de","3":"48fd66a7b8563289ea94669bc022bb0d150ec79b","4":"5ae35694817741f644ac421b7032e0a2a24717fb","5":"c05b8182","6":"component---src-pages-layout-js","7":"6a0e62c6bec831d65d7b3c8a2071de5a96f71698","8":"39a9bd22f798f30931384f4a216a4a26b9ea214f","9":"4ad82c5e","10":"e5c3b7340df50750ef3974bec0831a00a49c4484","11":"71b3ce269d1bb16850dca227076689472c051cab","12":"9ce52433c4e6227caea5918fbf2a0935fa2d2a80","21":"3dcc3d58","32":"c46c4a8f","35":"component---src-pages-404-js","36":"component---src-pages-banner-js","37":"component---src-pages-classic-home-js","38":"component---src-pages-docs-template-js","39":"component---src-pages-home-js","40":"component---src-pages-index-js","41":"component---src-pages-integration-builder-index-tsx","42":"component---src-pages-integration-builder-modals-test-experience-modal-tsx","43":"component---src-pages-integration-builder-sections-preview-tsx","44":"component---src-pages-integration-builder-steps-configure-integration-step-tsx","45":"component---src-pages-integration-builder-steps-test-integration-step-tsx","46":"component---src-pages-internal-js","47":"component---src-pages-signup-js","48":"component---src-pages-signupauto-js","49":"component---src-pages-support-js","50":"component---src-pages-thankyou-js","51":"component---src-pages-unsubscribe-js","52":"component---src-templates-template-layout-js","56":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"caf2febebf8046ef2e12","2":"a493be4dfdf5cc453e21","3":"f969cecc5abd4319b0f2","4":"5c3cc6f2299b3fe38b4c","5":"df6b6046e69251ca8097","6":"e92388c8577e6ccacff5","7":"a119e4b2c935a6e9a2b3","8":"cad7cd85f2e7205a40eb","9":"6f2f00afc16a1becc60e","10":"f521bd4435b259e7ed79","11":"f965d6cdd3ea52b1c512","12":"8ff02036168c41767371","21":"419041e7accded9ed1a5","32":"9574faaa4d1e19e7f023","35":"4be0a8ffaada85becba3","36":"3a55b314981f0739a05a","37":"a030658bc5b92672dc29","38":"6388317e082a3f011277","39":"89f8cca027a062233d92","40":"c91f8f1c07adc4cd2703","41":"2abdd4d6edcaa366eb94","42":"58ab77fcb6fd6ceadcb4","43":"14b4837f4b0f3b09385f","44":"5d6b83fa8c8cf5dd7703","45":"aaffdda6f39dc228d8eb","46":"9b56d19fbfbb7a7bee76","47":"506ca1eae903e5a38b52","48":"1b882332fc72025ae88e","49":"47d39866eb51857c01de","50":"c37bf7bb86517d1a4d6a","51":"0c5f47c12d11eb41572a","52":"53e0c5b55cb552f1bd1c","56":"0bc1e90825c3bbdbbc22","60":"71bfad2c179ab219dc06"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"360da5eca0b125ca379890c902ea6c3521fb822f","2":"b51fa1b0004917ec479d531c8197e862e26a29de","3":"48fd66a7b8563289ea94669bc022bb0d150ec79b","4":"5ae35694817741f644ac421b7032e0a2a24717fb","5":"c05b8182","6":"component---src-pages-layout-js","7":"6a0e62c6bec831d65d7b3c8a2071de5a96f71698","8":"39a9bd22f798f30931384f4a216a4a26b9ea214f","9":"4ad82c5e","10":"e5c3b7340df50750ef3974bec0831a00a49c4484","11":"71b3ce269d1bb16850dca227076689472c051cab","12":"9ce52433c4e6227caea5918fbf2a0935fa2d2a80","21":"3dcc3d58","32":"c46c4a8f","35":"component---src-pages-404-js","36":"component---src-pages-banner-js","37":"component---src-pages-classic-home-js","38":"component---src-pages-docs-template-js","39":"component---src-pages-home-js","40":"component---src-pages-index-js","41":"component---src-pages-integration-builder-index-tsx","42":"component---src-pages-integration-builder-modals-test-experience-modal-tsx","43":"component---src-pages-integration-builder-sections-preview-tsx","44":"component---src-pages-integration-builder-steps-configure-integration-step-tsx","45":"component---src-pages-integration-builder-steps-test-integration-step-tsx","46":"component---src-pages-internal-js","47":"component---src-pages-signup-js","48":"component---src-pages-signupauto-js","49":"component---src-pages-support-js","50":"component---src-pages-thankyou-js","51":"component---src-pages-unsubscribe-js","52":"component---src-templates-template-layout-js","56":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"329c232cded3d82c7acd","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.paypalobjects.com/ppdevdocs/bundle/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
